var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2476,
    height: 1768,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 -352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9206 1079.13 212.568 1655.54 566.3 396.906 758.886 2075.91 1074.73 800.641 1300.14 1414.28 1537.03 615.335 1724.38 1196.55 1988.92 1196.55",
    stroke: "#0C0D0D",
    strokeWidth: 88.2869,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2430.92 1191.91C2430.92 1313.96 2331.98 1412.91 2209.92 1412.91 2087.87 1412.91 1988.92 1313.96 1988.92 1191.91 1988.92 1069.85 2087.87 970.906 2209.92 970.906 2331.98 970.906 2430.92 1069.85 2430.92 1191.91Z",
    stroke: "#0C0D0D",
    strokeWidth: 88.2869,
    strokeLinecap: "round",
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.d1de908984e9c6b70e62c3b7fe7bf8b4.svg";
export { ForwardRef as ReactComponent };